import createComputed from 'modules/core/hooks/createComputed'
import type User from 'modules/core/store/models/User'

import type QuestionGroup from '../store/models/QuestionGroup'

export const useFilters = createComputed(
  (questionGroups: QuestionGroup[], surveyId: number, user: User) => {
    return questionGroups.filter(
      (questionGroup) =>
        questionGroup.attributes.surveys_form_id === surveyId &&
        questionGroup.attributes.respondent_id === user.attributes.id
    )
  }
)
